import { Component, computed, inject, input, OnInit } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { filter, switchMap } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';
import { Message, MessageService, MESSAGE_TYPES } from '@corelabs/angular/messages';
import { IconComponent } from '@shared/components';

const SEVERITY_ICONS: Record<MESSAGE_TYPES, IconType> = {
    success: 'circle-check',
    warning: 'triangle-exclamation',
    danger: 'circle-x',
    info: 'circle-info',
};

@Component({
    selector: 'app-message',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.css'],

    imports: [TranslatePipe, IconComponent],
    host: {
        '[class]': 'severity()',
        '(mouseenter)': 'messageService.onMouseEnter(message().id)',
        '(mouseleave)': 'messageService.onMouseLeave(message().id)',
    },
})
export class MessageComponent implements OnInit {
    readonly messageService = inject(MessageService);

    readonly message = input.required<Message>();

    readonly severity = computed<MESSAGE_TYPES>(() => this.message().severity ?? 'info');
    readonly icon = computed(() => SEVERITY_ICONS[this.severity()]);

    // progress$ emits the REMAINING fraction (ticks count down: ~1 → 0), paused by the service while hovered; null (reset on hide) is skipped to keep the last value during the leave animation
    readonly remaining = toSignal(
        toObservable(this.message).pipe(
            switchMap((message) => this.messageService.progress$(message.id)),
            filter((progress) => progress !== null),
        ),
        { initialValue: 1 },
    );

    ngOnInit(): void {
        this.messageService.show(this.message().id);
    }
}
